import * as XLSX from "xlsx";
import { getDishOptionsByName } from "./model/lunch";
import { sortBy } from "./sort";
import { getOrderedDishOptionValue } from "./model/userOrder";

const CHUNK_SIZE = 20;

const formatDishOptions = (selectedDishOptions, availableDishOptions) => {
    return availableDishOptions.reduce(
        (formattedOptions, {title, id}) => ({
            ...formattedOptions,
            [title]: getOrderedDishOptionValue(selectedDishOptions, id)
        }),
        {}
    );
}
const formatOrder = ({
                         firstName = '',
                         lastName = '',
                         additionalInfo = '',
                         dish = {}
                     },
                     index,
                     options
) => {
    const {name: dishName = '', options: dishOptions} = dish;
    const availableDishOptions = dishName ? getDishOptionsByName(options, dishName) : [];
    const formattedDishOptions = formatDishOptions(dishOptions, availableDishOptions);
    return ({
        Lp: index + 1,
        lastName,
        firstName,
        dishName,
        additionalInfo,
        ...formattedDishOptions
    });
}

const formatOrders = (orders, options) =>
    sortBy(orders, 'lastName')
        .map((order, index) => formatOrder(order, index, options));

const createOrdersSheet = (formattedOrders) => XLSX.utils.json_to_sheet(formattedOrders);

const createNumbersSheet = (formattedOrders) => {
    const formattedNumbers = formattedOrders
        .map(({Lp, lastName, firstName}) => ([
            Lp,
            lastName,
            firstName,
        ]))
        .reduce((chunks, item, index) => {
            const insertIndex = index % CHUNK_SIZE;
            const chunk = chunks[insertIndex] || [];
            chunks[insertIndex] = [...chunk, ...item];
            return chunks;
        }, []);
    return XLSX.utils.aoa_to_sheet(formattedNumbers);
};

const hashCode = (stringValue) => stringValue
    .split('')
    .reduce((a, b) => {
        a = ((a << 5) - a) + b.charCodeAt(0);
        return a & a;
    }, 0);

const USER_INFO_KEYS = ['Lp', 'lastName', 'firstName'];
const createDishInfo = (order) => Object.keys(order).reduce((dishInfo, key) =>
        USER_INFO_KEYS.includes(key) ? dishInfo : {...dishInfo, [key]: order[key]},
    {}
);

const createGroupName = (order) => {
    const dishInfo = createDishInfo(order);
    return hashCode(Object.values(dishInfo).join());
};

const createOrderSummarySheet = (formattedOrders) => {
    const groupedDishes = Object.values(formattedOrders
        .reduce((groups, order) => {
            const groupName = createGroupName(order);
            const existingDishOrders = groups[groupName] || [];
            return {...groups, [groupName]: [...existingDishOrders, order]};
        }, {}))
        .map((group) => {
            const order = group[0];
            const dishInfo = createDishInfo(order);
            const numbers = group.map(({Lp}) => Lp).join(', ');
            return {count: group.length, numbers, ...dishInfo};
        });
    const orderSummary = sortBy(groupedDishes, 'dishName')
        .map((group, index) => ({Lp: index + 1, ...group}));
    return XLSX.utils.json_to_sheet(orderSummary);
}

export const exportOrdersToFile = (officeLabel, title, extension, orders, options) => {
    const formattedOrders = formatOrders(orders, options);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, createOrdersSheet(formattedOrders), "Orders");
    XLSX.utils.book_append_sheet(wb, createOrderSummarySheet(formattedOrders), "Order summary");
    XLSX.utils.book_append_sheet(wb, createNumbersSheet(formattedOrders), "Numbers");
    XLSX.writeFile(wb, `${officeLabel} - ${title}.${extension}`);
}
